module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "tutorial-settings-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.loading) ? _c('vue-spinner') : [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tutorial-header"
    }
  }, [_vm._v("Header")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutorialData.header),
      expression: "tutorialData.header"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Header",
      "name": "tutorial-header",
      "id": "tutorial-header"
    },
    domProps: {
      "value": (_vm.tutorialData.header)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutorialData, "header", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tutorial-subheader"
    }
  }, [_vm._v("Subheader")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutorialData.subheader),
      expression: "tutorialData.subheader"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Subheader",
      "name": "tutorial-subheader",
      "id": "tutorial-subheader"
    },
    domProps: {
      "value": (_vm.tutorialData.subheader)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutorialData, "subheader", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tutorial-download-as"
    }
  }, [_vm._v("Download as (filename)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutorialData.filename),
      expression: "tutorialData.filename"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "File name",
      "name": "tutorial-download-as",
      "id": "tutorial-download-as"
    },
    domProps: {
      "value": (_vm.tutorialData.filename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutorialData, "filename", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tutorial-category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutorialCategoryId),
      expression: "tutorialCategoryId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tutorial-category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tutorialCategoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.title))])
  }), 0)]), _vm._v(" "), (_vm.tutorialData.thumbFile || _vm.thumb.length) ? _c('div', {
    staticClass: "thumb-preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.thumbUrl(),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-thumb"
  }, [_c('div', {
    staticClass: "example-btn"
  }, [_c('file-upload', {
    ref: "thumbUpload",
    staticClass: "btn green",
    attrs: {
      "post-action": _vm.uploadEndpoint,
      "data": {
        'tutorialId': _vm.id
      },
      "extensions": "jpg,png,jpeg",
      "accept": "image/png,image/jpg,image/jpeg",
      "multiple": false,
      "size": 1024 * 1024 * 10,
      "headers": {
        'token': _vm.token
      },
      "input-id": 'tutorial-upload-thumb'
    },
    on: {
      "input-filter": _vm.inputFilter,
      "input-file": _vm.inputFile
    },
    model: {
      value: (_vm.thumb),
      callback: function($$v) {
        _vm.thumb = $$v
      },
      expression: "thumb"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Upload thumb file\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.loadingThumb) ? _c('vue-spinner') : _vm._e()], 1)], 1)])]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateSettings.apply(null, arguments)
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeTutorial.apply(null, arguments)
      }
    }
  }, [_vm._v("Remove tutorial")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("TUTORIAL SETTINGS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3703848","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpTutorials/TutorialSettingsModal.vue
// module id = 1742
// module chunks = 1